import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BaseModalComponent } from '../base-modal/base-modal.component';

@Component({
  standalone: true,
  selector: 'app-confirmation-modal',
  imports: [MatButtonModule, MatIconModule, MatDialogModule, BaseModalComponent],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss',
})
export class ConfirmationModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; content?: string; confirmButtonText?: string },
    private readonly dialogRef: MatDialogRef<ConfirmationModalComponent>,
  ) {
    this.dialogRef.updateSize('15w');
    this.dialogRef.disableClose = true;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
